<span>
  <ng-content></ng-content>
</span>
<span *ngIf="isPending" class="load" [attr.appearance]="appearance"></span>
